













import { Component, Mixins } from 'vue-property-decorator'
import StudyResultAnswers from '@/components/common/organisms/StudyResultAnswers.vue'
import StudyResultApis, { StudyResultData } from '@/mixins/requests/branch/StudyResultApis.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'

@Component({
  components: {
    StudyResultAnswers,
    ButtonBase,
  },
})
export default class StudyResult extends Mixins(StudyResultApis) {
  private studyResultData: StudyResultData | null = null

  private get acbtCode() {
    return this.$route.params.acbtCode
  }

  private async mounted() {
    this.studyResultData = await this.getStudyResultData(this.acbtCode)
  }

  private back() {
    this.$router.push({ name: 'BranchStudentList' })
  }
}
